// extracted by mini-css-extract-plugin
export default {"big":"massage-text_big__Qd14X","text":"massage-text_text__-FFkC"};